export default __webpack_public_path__ + "img/ccrsotIC.33e9bcd8.svg";